import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Enregistrer le service worker pour PWA
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ Stress Management Test est maintenant disponible hors ligne !');
  },
  onUpdate: (registration) => {
    console.log('🔄 Nouvelle version disponible !');
    // Optionnel : afficher une notification à l'utilisateur
  }
});
